/** Amounts are currency units, already resolved from the selected service/option. */
export function resolveCustomerPrepayment(
  totalPrice: number,
  serviceChargeNow: number,
  gateRequired: boolean,
) {
  const round = (amount: number) => Math.round(amount * 100) / 100;
  const total = round(totalPrice);
  const baseCharge = round(serviceChargeNow);
  const customerPrepayment = gateRequired && total > baseCharge;
  // Customer DEPOSIT means the whole selection, never an additional charge.
  const chargeNow = customerPrepayment ? total : baseCharge;
  return {
    customerPrepayment,
    chargeNow,
    dueLater: round(Math.max(0, total - chargeNow)),
  };
}
